var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 16C30 23.732 23.732 30 16 30C8.268 30 2 23.732 2 16C2 8.26801 8.268 2 16 2C23.732 2 30 8.26801 30 16ZM23.7778 17.5556C24.6369 17.5556 25.3333 16.8591 25.3333 16C25.3333 15.1409 24.6369 14.4445 23.7778 14.4445H8.22222C7.36311 14.4445 6.66667 15.1409 6.66667 16C6.66667 16.8591 7.36311 17.5556 8.22222 17.5556H23.7778Z",
    fill: "currentColor"
  })));
};
export default SvgDelete;